// src/components/ShowcaseDemos.jsx
import Reveal from "./Reveal";
const BASE =
  typeof process !== "undefined" && process.env && process.env.PUBLIC_URL
    ? process.env.PUBLIC_URL
    : "";

const demos = [
  {
    id: 1,
    title: "National Network",
    desc: "Top mass-tort partners across the U.S.",
    img: "/feature/network.jpg", // ← use this exact path
    btn: "Meet Our Network",
    href: "#network",
  },

  {
    id: 2,
    title: "Fast Case Review",
    desc: "Confidential intake — minutes to start.",
    img: "/feature/fast-review.jpg", // put an image here
    btn: "Get Reviewed",
    href: "#review",
  },
  {
    id: 3,
    title: "Intake-Focused",
    desc: "Hero form, trust badges, straight to eligibility.",
    img: "/feature/intake-style.jpg", // put an image here
    btn: "Preview Style",
    href: "#intake-style",
  },
];

export default function ShowcaseDemos() {
  return (
    <section className="py-20 bg-[#F5F7FA]">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center px-3 py-1 rounded-full text-sm font-semibold bg-[#F3E7C9] text-[#916F20] mb-4">
            Your Home Style
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#0A2540]">
            What You Get With Us
          </h2>
          <p className="text-slate-600 mt-2 max-w-2xl mx-auto">
            Experience, speed, and conversion-focused design for mass-tort
            intake.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 items-stretch">
          {demos.map((d, i) => (
            <Reveal key={d.id || i} delay={i * 120} className="h-full">
              <article
                className="h-full group bg-white rounded-3xl border border-slate-200 overflow-hidden shadow-sm
                           transition-all duration-300 hover:-translate-y-2 hover:border-[#C89B3C]
                           hover:shadow-lg hover:ring-2 hover:ring-[#C89B3C]/30 flex flex-col"
              >
                <div className="h-48 overflow-hidden flex-shrink-0">
                  <img
                    src={d.img}
                    alt={d.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
                  />
                </div>
                <div className="p-6 text-left flex-1 flex flex-col">
                  <h3 className="text-lg font-semibold text-[#0A2540]">
                    {d.title}
                  </h3>
                  <p className="mt-2 text-sm text-slate-600 flex-1">{d.desc}</p>
                  <a
                    href={d.href}
                    className="mt-5 inline-flex items-center justify-center rounded-full px-5 py-2 text-sm font-semibold text-white
                               bg-[#C89B3C] transition hover:opacity-90 shadow-[0_4px_12px_rgba(200,155,60,0.35)]"
                  >
                    {d.btn}
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
